/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Update_ButtonInputs */

const en_options_api_keys_update_button = /** @type {(inputs: Options_Api_Keys_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update`)
};

const fr_options_api_keys_update_button = /** @type {(inputs: Options_Api_Keys_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour`)
};

const de_options_api_keys_update_button = /** @type {(inputs: Options_Api_Keys_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisieren`)
};

const it_options_api_keys_update_button = /** @type {(inputs: Options_Api_Keys_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornamento`)
};

const ru_options_api_keys_update_button = /** @type {(inputs: Options_Api_Keys_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновлять`)
};

const es_options_api_keys_update_button = /** @type {(inputs: Options_Api_Keys_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar`)
};

const zh_cn2_options_api_keys_update_button = /** @type {(inputs: Options_Api_Keys_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新`)
};

const ja_options_api_keys_update_button = /** @type {(inputs: Options_Api_Keys_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップデート`)
};

const hi_options_api_keys_update_button = /** @type {(inputs: Options_Api_Keys_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अद्यतन`)
};

const pt_pt2_options_api_keys_update_button = /** @type {(inputs: Options_Api_Keys_Update_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar`)
};

/**
* | output |
* | --- |
* | "Update" |
*
* @param {Options_Api_Keys_Update_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_update_button = /** @type {((inputs?: Options_Api_Keys_Update_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Update_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_update_button(inputs)
	if (locale === "de") return de_options_api_keys_update_button(inputs)
	if (locale === "it") return it_options_api_keys_update_button(inputs)
	if (locale === "ru") return ru_options_api_keys_update_button(inputs)
	if (locale === "es") return es_options_api_keys_update_button(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_update_button(inputs)
	if (locale === "ja") return ja_options_api_keys_update_button(inputs)
	if (locale === "hi") return hi_options_api_keys_update_button(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_update_button(inputs)
	return en_options_api_keys_update_button(inputs)
});